import { t } from "../../i18n";
import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ProjectSchema } from "@tasduvar/engine";
import { api, errorMessage, isApiError } from "../../api/client";
import { useProjectStore } from "../../state/projectStore";
import { ReportPage } from "../report/ReportPage";
import { CadShell } from "../cad/CadShell";
import { ModelLayout } from "../cad/ModelLayout";

interface Shared { allowDownload: boolean; name: string }

/** /paylasim/:token — oturumsuz, salt okunur proje görünümü; `report` ile rapor sayfası. */
export function SharePage({ report = false }: { report?: boolean }): JSX.Element {
  const { token = "" } = useParams();
  const { project, openProject, origin } = useProjectStore();
  const [shared, setShared] = useState<Shared | null>(null);
  const [err, setErr] = useState<string>();
  useEffect(() => {
    let alive = true;
    api<{ project: unknown; name: string; allowDownload: boolean }>("GET", `/share/${encodeURIComponent(token)}`)
      .then((r) => { if (!alive) return; openProject(ProjectSchema.parse(r.project), "shared"); setShared({ allowDownload: r.allowDownload, name: r.name }); })
      .catch((e: unknown) => setErr(isApiError(e) && e.status === 404 ? "Bu paylaşım bağlantısı geçersiz, iptal edilmiş ya da süresi dolmuş." : errorMessage(e)));
    return () => { alive = false; };
  }, [token]);
  if (err) return <main className="min-h-screen grid place-items-center p-6"><div className="card p-6 max-w-md grid gap-3"><h1 className="text-lg font-semibold text-accent">{t("TaşDuvar")}</h1><p role="alert" className="text-sm text-bad">{err}</p><Link to="/" className="btn-ghost">{t("Ana sayfa")}</Link></div></main>;
  if (!project || !shared || origin !== "shared") return <p className="p-6 text-stone">{t("Yükleniyor…")}</p>;
  if (report) return <ReportPage share={{ token, allowDownload: shared.allowDownload }} />;
  // Model paftasının salt-okunur kipi (README §4.4): QAT etiketi, şeritte yazma düğmeleri kapalı, komut satırı devre dışı
  return (
    <CadShell current="project" share={{ token, allowDownload: shared.allowDownload }}>
      <ModelLayout />
    </CadShell>
  );
}
